import { captureException } from '@sentry/browser';
import { ZodError } from 'zod';

import { apiClient } from '@f/api-client';

import { createAction } from '../actions';
import { initReportDesigningMode } from '../report/report.actions';
import { sessionStorageClient } from '../storage/wrapper';

const baseUrl = `${window.location.origin}/internal`;

export const SIGN_IN_START = 'SIGN_IN_START';
export const SIGN_IN_FULFILL = 'SIGN_IN_FULFILL';
export const SIGN_IN_REJECT = 'SIGN_IN_REJECT';

export function signIn() {
  return async (dispatch, getState) => {
    dispatch(createAction(SIGN_IN_START));

    try {
      const result = await apiClient.auth.getUser();

      if (result.status !== 200) {
        throw new Error(result.body);
      }

      const user = result.body;

      if (!user?.isLoggedIn) {
        dispatch(createAction(SIGN_IN_REJECT, null));
        initHubspotConversations();
        return;
      }

      dispatch(createAction(SIGN_IN_FULFILL, user));
      initReportDesigningMode()(dispatch, getState);

      setupHubspotVisitor(user.email);

      return user;
    } catch (error) {
      if (error instanceof ZodError) {
        captureException(error);
      }
      // Rejects
      dispatch(createAction(SIGN_IN_REJECT, error));

      initHubspotConversations();

      return error;
    }
  };
}

export function signOut() {
  clearHubspotConversations();
  sessionStorageClient.clear();
  window.location.assign(`${baseUrl}/auth/sign-out`);
}

function initHubspotConversations(settings = {}) {
  window.hsConversationsSettings = settings;

  function loadWidget() {
    window.HubSpotConversations.widget.load();
  }

  if (window.HubSpotConversations) {
    loadWidget();
    return;
  }
  window.hsConversationsOnReady = [loadWidget];
}

async function setupHubspotVisitor(email) {
  try {
    const { status, body: visitorToken } = await apiClient.config.fetchVisitorToken({
      body: { email },
    });
    if (status !== 200) {
      return;
    }
    initHubspotConversations({
      identificationEmail: email,
      identificationToken: visitorToken,
    });
  } catch (error) {
    console.warn('Failed to setup Hubspot visitor', error);
    initHubspotConversations();
  }
}

function clearHubspotConversations() {
  if (window.HubSpotConversations) {
    window.HubSpotConversations.clear({ resetWidget: true });
  }
}
